import React from "react";
import { useSearchParams } from "react-router-dom";

import { useEntityDetailContext } from "contexts/EntityDetailContext";

import AppTable from "components/Shared/AppTable/AppTable";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { useListEntityUsersQuery } from "store/services/entityApi";
import { useTablePagination } from "hooks";

const EntityUsers = ({ entityId }) => {
  const { entityDetail } = useEntityDetailContext();
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("search") || "";

  const { data: usersResponse, isLoading, isFetching } =
    useListEntityUsersQuery({
      id: entityId || entityDetail?._id,
      page: currentPage,
      limit: perPage,
      ...(keyword && { keyword }),
    }, { skip: !(entityId || entityDetail?._id) });

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name,
      cell: (row) => (
        <OpenInNewTab
          label={row?.name}
          link={`/app/crm/user/${row?._id}/detail`}
        />
      ),
    },
    { name: "Email", selector: (row) => row?.email },
  ];

  return (
    <>
      <TableFilter
        searchLabel="Name/Email"
        disabled={isLoading || isFetching}
        initialFilters={2}
      />
      <AppTable
        columns={columns}
        data={usersResponse?.data ?? []}
        progressPending={isLoading || isFetching}
        paginationServer
        paginationPerPage={perPage}
        paginationTotalRows={usersResponse?.totalItems ?? 0}
        paginationDefaultPage={currentPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
    </>
  );
};

export default EntityUsers;
